/**
 * @file
 * Renders client-side messages (AJAX commands, BigPipe) as <wa-callout>.
 *
 * The status-messages Twig override only covers server-rendered messages;
 * anything added through Drupal.Message goes through Drupal.theme.message.
 */
const VARIANTS = {
  status: ['success', 'check-circle'],
  warning: ['warning', 'alert-triangle'],
  error: ['danger', 'alert-circle'],
};

Drupal.theme.message = ({ text }, { type, id }) => {
  const [variant, icon] = VARIANTS[type] || ['neutral', 'info'];
  const callout = document.createElement('wa-callout');
  callout.setAttribute('variant', variant);
  callout.setAttribute('open', '');
  callout.setAttribute('role', type === 'error' ? 'alert' : 'status');
  callout.setAttribute('aria-label', Drupal.t('@type message', { '@type': type }));
  callout.setAttribute('data-drupal-message-id', id);
  callout.setAttribute('data-drupal-message-type', type);
  callout.innerHTML = `<wa-icon name="${icon}" slot="icon"></wa-icon>`;
  callout.insertAdjacentHTML('beforeend', text);

  return callout;
};
